/* RESPONSIBLE TEAM: team-proactive-support */
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import StandardPanelHeaderConfiguration from 'embercom/objects/content-editor/panels/standard-panel-header-configuration';

export default class GenericTriageHeaderConfiguration extends StandardPanelHeaderConfiguration {
  @service contentEditorService;
  @service intl;
  @service appService;

  get genericTriageErrors() {
    return this.contentEditorService.activeObject.validations.attrs.genericTriageLocalizations
      .errors;
  }

  get errors() {
    if (this.genericTriageErrors.length > 1) {
      return [{ message: this.intl.t('ai-agent.profiles.handover.finish') }];
    } else {
      return this.genericTriageErrors;
    }
  }

  get isComplete() {
    return isEmpty(this.errors);
  }

  init(inputs) {
    inputs.component = 'content-editor/panels/custom/ai-agent-profile/generic-triage/header';
    inputs.title = this.intl.t('ai-agent.profiles.config-generator.handover');
    super.init(...arguments);
  }
}
